import { useRoutes } from "react-router-dom"

import { DetailSegmentSelectListener, SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterBoundingBox, MapAdapterRoad } from "@l2r-front/l2r-networks"
import { NavigateWithParams, useUrlParams } from "@l2r-front/l2r-utils"

import { HorizontalSignDetailsSidebar } from "../../containers/HorizontalSignDetailsSidebar"
import { HorizontalSigningMobileContent } from "../../containers/HorizontalSigningMobileContent"
import { HorizontalSignSelectListener } from "../../containers/HorizontalSignSelectListener"

import { HorizontalSignValidator } from "../HorizontalSignValidator"

export const HorizontalSigningMobileRoutes = () => {
    const { getParams } = useUrlParams()
    const searchParams = getParams()

    const horizontalSigningRoutes = useRoutes([
        {
            path: "/*",
            element: <>
                <MapAdapterBoundingBox />
                <HorizontalSigningMobileContent />
                <SegmentSelectListener />
            </>,
        },
        {
            path: "/code/:code",
            element: <>
                <MapAdapterBoundingBox />
                <HorizontalSigningMobileContent />
                <SegmentSelectListener />
            </>,
        },
        {
            path: "/:road",
            element: <>
                <DetailSegmentSelectListener />
                <MapAdapterRoad />
                <HorizontalSigningMobileContent />
            </>,
        },
        {
            path: "/:road/:signId",
            element: <HorizontalSignValidator>
                <HorizontalSignSelectListener />
                <HorizontalSignDetailsSidebar />
            </HorizontalSignValidator>,
        },
        {
            path: "/:road/code/:code",
            element: <>
                <DetailSegmentSelectListener />
                <MapAdapterRoad />
                <HorizontalSigningMobileContent />,
            </>,
        },
        {
            path: "/:road/code/:code/:signId",
            element: <HorizontalSignValidator>
                <HorizontalSignSelectListener />
                <HorizontalSignDetailsSidebar />
            </HorizontalSignValidator>,
        },
        {
            path: "/:road/*",
            element: <NavigateWithParams replace to={`../:road?${searchParams}`} />,
        },
    ])

    return horizontalSigningRoutes
}